import { Button } from '@customerio/pluma-components/react';
import * as styles from './index.css';

export function SkipToContent() {
  return (
    // oxlint-disable-next-line pluma/enforce-pluma-elements -- native anchor semantics are required so the skip link performs an in-page hash jump instead of Pluma's client-side route navigation.
    <Button as="a" href="#embedded-app-container" size="sm" className={styles.skipToContent} zIndex="tooltip">
      Skip to content
    </Button>
  );
}
